import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import {
	fetchConfluenceLink,
	fetchConfluenceLinkRestful,
} from '@atlassian/jira-servicedesk-knowledge-services';

import { FETCH_KB_HUB } from '../../state/actions/fetch-knowledge-hub';
import { fetchKbHubFailure } from '../../state/actions/fetch-knowledge-hub-failure';
import { fetchKbHubSuccess } from '../../state/actions/fetch-knowledge-hub-success';
import { getProjectKey } from '../../state/selectors/base';
import { getHubLinkedState } from '../../state/selectors/hub';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: any) =>
	action$.ofType(FETCH_KB_HUB).mergeMap((action) => {
		const state = store.getState();
		const projectKey = getProjectKey(state);

		const linkedState = getHubLinkedState(state);

		if (linkedState === 'linked') {
			return Observable.empty<never>();
		}

		// Try wrmClaim
		return fetchConfluenceLink(action.payload.projectKey)
			.mergeMap((link) => Observable.of(fetchKbHubSuccess(link)))
			.catch(() =>
				// wrmClaim REST fallback
				Observable.fromPromise(fetchConfluenceLinkRestful(projectKey))
					.map((link) => fetchKbHubSuccess(link))
					.catch((err) => Observable.of(fetchKbHubFailure(err))),
			);
	});
